module.exports = __webpack_public_path__ + "static/media/groups-active.ca45574f.svg";